import React from 'react';
import { motion } from 'framer-motion';

function Contact() {
  return (
    <motion.section 
      id="contact" 
      className="contact"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, delay: 0.2 }}
    >
      <h2>Contactează-mă</h2>
      <p>Sunt deschis la noi idei și colaborări. Aștept cu drag mesajul tău!</p>
      <div className="contact-links">
        <a href="mailto:flavius@flavy.us" className="cta-button">Email</a>
        <a href="https://instagram.com/flvdumi" target="_blank" rel="noopener noreferrer" className="cta-button">Instagram</a>
        <a href="https://github.com/flvdumi" target="_blank" rel="noopener noreferrer" className="cta-button">GitHub</a>
      </div>
    </motion.section>
  );
}

export default Contact;